let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4iCkc")).then(() => parcelRequire('bSFP6'));